import { render, staticRenderFns } from "./HorariosEmpleados.vue?vue&type=template&id=ffba0954&"
import script from "./HorariosEmpleados.vue?vue&type=script&lang=js&"
export * from "./HorariosEmpleados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports